function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgTray(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    viewBox: "190.479 182.269 153.603 107.522",
    width: 153.603,
    height: 107.522,
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, /*#__PURE__*/React.createElement("path", {
    fill: "currentColor",
    d: "M 313.361 182.269 L 221.199 182.269 L 221.199 197.629 L 313.361 197.629 M 221.199 212.989 L 313.361 212.989 L 313.361 228.35 L 221.199 228.35 M 190.479 236.03 L 205.839 236.03 L 205.839 274.431 L 328.721 274.431 L 328.721 236.03 L 344.082 236.03 L 344.082 274.431 C 344.082 282.909 337.208 289.791 328.721 289.791 L 205.839 289.791 C 197.353 289.791 190.479 282.909 190.479 274.431 M 313.361 243.71 L 221.199 243.71 L 221.199 259.07 L 313.361 259.07 L 313.361 243.71 Z",
    style: {},
    transform: "matrix(1, 0, 0, 1, 0, 3.552713678800501e-15)"
  }));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgTray);
export default __webpack_public_path__ + "static/media/tray.cab955e3.svg";
export { ForwardRef as ReactComponent };